import { createSlice, isAnyOf } from '@reduxjs/toolkit';
import { getAllDisplayData, getAllDisplayDataLocked } from '../pathways/displaySlice';

/* ----------------------------------------------------------------
      SLICE (ACTIONS/REDUCERS)
---------------------------------------------------------------- */

const initialState = {
  state: false,
  showModal: false,
  options: {
    class: 'Modal',
    overlay: 'Overlay',
    children: 'Hi',
  },
};

const dialogSlice = createSlice({
  name: 'dialog',
  initialState,
  reducers: {
    closeDialog(state) {
      state.state = false;
    },
    openDialog(state, action) {
      state.state = true;
      state.options = action.payload;
    },
    calcNew(state) {
      state.showModal = false;
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(isAnyOf(getAllDisplayData.fulfilled, getAllDisplayDataLocked.fulfilled), (state, action) => {
      state.showModal = action.payload.showModal;
    });
  },
});

export const { closeDialog, openDialog, calcNew } = dialogSlice.actions;
export default dialogSlice.reducer;
